import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ModalModule, CarouselModule } from "ngx-bootstrap";
import { OnboardingComponent } from './onboarding/onboarding.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CarouselModule.forRoot()
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    OnboardingComponent
  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent
  ],
  entryComponents: [
    OnboardingComponent
  ]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/components/main/components.module.ts